/* src/app/components/media-player/media-player-component.scss */
.cs-media-player {
  width: 400px;
  z-index: 1000;
  position: absolute;
  bottom: 13%;
  left: 4%;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  animation-name: fadeInLeft;
  box-shadow: 0 -3px 5px 0px rgba(62, 85, 161, 0.31), 0 0 0 1px rgba(62, 85, 161, 0);
}
.cs-media-player i.vid-close {
  position: absolute;
  right: 0;
  padding: 10px;
  color: #fff;
  z-index: 1000;
  cursor: pointer;
  display: none;
  text-align: right;
  opacity: 0.5;
  background: #000;
}
.cs-media-player i.aud-close {
  -webkit-user-select: none;
  user-select: none;
  display: flex;
  justify-content: center;
  height: 50px;
  width: 40px;
  cursor: pointer;
  color: white;
  line-height: 50px;
}
.cs-media-player:hover i.fa-times {
  display: block;
}
@keyframes fadeInLeft {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
/*# sourceMappingURL=media-player-component.css.map */
